import {
    FETCH_FORGOT_CONTENT,
    FETCH_FORGOT_CONTENT_SUCCESS,
    FETCH_FORGOT_CONTENT_FAILED,
    FORGOT_MESSAGE,
    FORGOT_MESSAGE_SUCCESS,
    FORGOT_MESSAGE_FAILED,
} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    content: {},
    error: false,
    isFormProcessing: false,
    emptyFormData: false,
};

export default function (state = initialState, { type, payload }) {
    switch (type) {
        case FETCH_FORGOT_CONTENT:
            return {
                ...state,
                isLoading: true,
                content: {},
            };
        case FETCH_FORGOT_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload,
            };
        case FETCH_FORGOT_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            };
        case FORGOT_MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case FORGOT_MESSAGE_SUCCESS:
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case FORGOT_MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };

        default:
            return state;
    }
}
